<template>
  <!-- <pre>{{ groupedItems }}</pre> -->
  <canvas v-show="ready" id="dailyShift" ref="dailyShift" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStyle } from "@coreui/coreui-pro/dist/js/coreui-utilities";
import _ from "lodash";

const brandPrimary = getStyle("--primary");
const brandSecondary = getStyle("--secondary");
const brandSuccess = getStyle("--success");
const brandWarning = getStyle("--warning");
const brandDanger = getStyle("--danger");
const brandInfo = getStyle("--info");

const CHART_COLORS = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(255, 159, 64)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
];

export default {
  props: ["client_customer", "from_date", "to_date", "product", "process_type"],
  methods: {
    calculate(i) {
      return this.percentage[i];
    }
  },
  data() {
    return {
      ready: false,
      items: [],
      labels: [1, 2, 3, 4, 5, 6],
      data: []
    };
  },
  computed: {
    groupedItems() {
      return _.groupBy(this.items, (item) => item.date);
    }
  },
  async mounted() {
    const self = this;
    let buildedDatasets = [];
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/process/daily_shift?client_customer=${this.client_customer}&product=${this.product}&process_type=${this.process_type}&from_date=${this.from_date}&to_date=${this.to_date}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.items = response.data;
      const groupedDataByDate = _.groupBy(this.items, (item) => item.date);
      const groupedDataByShift = _.groupBy(this.items, (item) => item.shift);
      this.labels = Object.keys(groupedDataByDate);

      for (let [index, sh] of Object.keys(groupedDataByShift).entries()) {
        const dataset = {
          type: "bar",
          fill: true,
          label: sh,
          backgroundColor: CHART_COLORS[index],
          // stack: "Stack 0",
          data: [],
          data_exp: []
        };
        for (let date of Object.keys(groupedDataByDate)) {
          const obj = groupedDataByDate[date].find((obj) => obj.shift === sh);
          if (obj) {
            dataset.data.push(obj.net_kilograms);
            dataset.data_exp.push(obj.exportable_kilograms);
          } else {
            dataset.data.push(0);
            dataset.data_exp.push(0);
          }
        }
        this.data.push(dataset);
      }

      this.loading = false;
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    this.ready = true;
    let ctx = this.$refs.dailyShift.getContext("2d");
    const dailyShift = new Chart(ctx, {
      type: "bar",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      // plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: true
          },
          title: {
            display: true,
            text: "Kg volteados por turno por día"
          },
          tooltip: {
            callbacks: {
              afterBody: function (context) {
                const idx = context[0].dataIndex;
                const value =
                  (parseFloat(context[0].dataset.data_exp[idx]) / parseFloat(context[0].dataset.data[idx])) * 100;

                // const total = context[0].dataset.data.reduce((a, b) => a + parseFloat(b), 0);
                return "Embalaje: " + value.toFixed(2) + "%";
              }
            }
          },
          subtitle: {
            display: true,
            text: "Mas porcentaje de embalaje"
          }
        },
        scales: {
          x: {
            // stacked: true
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
